import { Outlet } from "react-router-dom";
import { useHasMessagesAccess } from "../hooks/useHasMessagesAccess";
import { NotFound } from "../../pages/NotFound";

export const MessagesProvider = () => {
  const { canViewMessages } = useHasMessagesAccess();

  return canViewMessages ? <Outlet /> : <NotFound />;
};
